import React from 'react';
import { History } from 'history';
import { Chip, Input, InputMultiline, InputDate, InputSelect, InputPicklist, InputFile } from '../../components';
import { Grid } from '@mui/material';
import BaseCreate from '../base/base-create.component'; 
import BaseList from '../base/base-list.component';
import Model from './transaction-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import TransactiontypeModel from '../transactiontype/transactiontype-model';
import OwnerPicklist from '../owner/owner-picklist.component';
import TransactiontypePicklist from '../transactiontype/transactiontype-picklist.component';
import PersonalinfoPicklist from '../personalinfo/personalinfo-picklist.component';
import DivisionPicklist from '../division/division-picklist.component';
import SchedulePicklist from '../schedule/schedule-picklist.component';
import TransactionpaymentCreate from '../transactionpayment/transactionpayment-create.component';   
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    caption?: string;
    transactiontypeType?: string;
    transactionType?: string;
    disableFields?: any;
    datarow?: any;
    save?: boolean;
    onSave?: (data: any) =>void;
    onError?: (data: any) =>void;
    disableView?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
    save?: boolean;
    saveTransactionpayment?: boolean;
}

export default class TransactionCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
            save: false,
            saveTransactionpayment: false,
        } 
        this.onChange = this.onChange.bind(this);
    }

    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadTransactiontype = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'transactiontype': data?.id, 'transactiontypeCaption': data?.name || ''  }  });
    }
    
    private onLoadCustomer = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'customer': data?.id, 'customerCaption': data?.name || ''  }  });
    }
    
    private onLoadEmployee = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'employee': data?.id, 'employeeCaption': data?.name || ''  }  });
    }
    
    private onLoadVendor = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'vendor': data?.id, 'vendorCaption': data?.name || ''  }  });
    }
    
    private onLoadDivision = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'division': data?.id, 'divisionCaption': data?.name || ''  }  });
    }
    
    private onLoadSchedule = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'schedule': data?.id, 'scheduleCaption': data?.name || ''  }  });
    }

    private onLoadAllTransactiontype = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'transactiontype': data?.[0]?.id, 'transactiontypeCaption': data?.[0]?.name || ''  } });
    }

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{id:this.state.datarow.imageId, files: data, ref: Model.endPointMedia, field:'image'}}});
    }

    private onError = (data: any) => {
        if (data) {
            this.setState({errors: data, save: false});
            this.props.onError?.(data)
        }
    }
    
    private onSave = async (data: any) => {
        if (data.id)
            this.setState({datarow: {...this.state.datarow, id: data.id}, save: false, saveTransactionpayment: true});
    }

    private onErrorTransactionpayment = (data: any) => {
        this.setState({saveTransactionpayment: false});
    }
    
    private onSaveTransactionpayment = (data: any) => {
        this.setState({saveTransactionpayment: false});
        this.props.onSave?.(this.state.datarow);
    }

    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    public componentDidUpdate() {
        if (this.props.save && this.props.save !== this.state.save && this.props.datarow.customer > 0 && !this.state.datarow.id && this.state.datarow.transactiontype > 0)
            this.setState({datarow: {...this.state.datarow, ...this.props.datarow, 'transactiontype': this.state.datarow.transactiontype}, save: true});
    }

    render() {
        return (
            //editable..  
            <>
            <BaseCreate history={this.props.history} caption={this.props.disableView? ' ' : ''} buttonCaption={this.state.datarow.transactiontype && !this.props.disableView? '' : ' '}
                model={Model} datarow={this.state.datarow} onError={this.onError} save={this.state.save} onSave={this.onSave} disableAutoBack={this.props.disableView} disableBackButton={this.props.disableView} disableCard={this.props.disableView}>
                        
                <BaseList history={this.props.history} caption=' ' endPointFilter={TransactiontypeModel.endPointFilterList(this.props.transactiontypeType || '')} model={TransactiontypeModel} onLoadAll={this.onLoadAllTransactiontype} disableView/>
                
                {!this.props.disableView &&
                <>
                {this.props.disableFields?.includes('transactionType') && !this.state.datarow.transactiontype?
                <Grid container justifyContent='center'><Chip label='Transaction is not allowed, possible transaction type is missing' type='error'/></Grid>
                :
                <>
                <InputSelect name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly />
                <Input name='name' label='Number' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {!this.props.disableFields?.includes('owner') && AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                }
                {!this.props.disableFields?.includes('transactionType') &&
                <InputPicklist name='transactiontype' label={'Transaction Type' +this.props.transactiontypeType} value={this.state.datarow.transactiontype || this.props.transactionType} caption={this.state.datarow.transactiontypeCaption} error={this.state.errors?.transactiontype} onChange={this.onChange} >
                    <TransactiontypePicklist transactiontypeType={this.props.transactiontypeType} currentId={this.state.datarow.transactiontype} onLoad={this.onLoadTransactiontype}/>
                </InputPicklist>
                }
                <InputDate name='transactiondate' label='Date' value={this.state.datarow.transactiondate} error={this.state.errors?.transactiondate} onChange={this.onChange} />            
                <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                {!this.props.disableFields?.includes('customer') &&
                <InputPicklist name='customer' label='Customer' value={this.state.datarow.customer} caption={this.state.datarow.customerCaption} clearValue={this.onLoadCustomer} error={this.state.errors?.customer} onChange={this.onChange} >
                    <PersonalinfoPicklist personalinfotypeType='customer' currentId={this.state.datarow.customer} onLoad={this.onLoadCustomer}/>
                </InputPicklist>
                }  
                {!this.props.disableFields?.includes('vendor') &&
                <InputPicklist name='vendor' label='Vendor' value={this.state.datarow.vendor} caption={this.state.datarow.vendorCaption} clearValue={this.onLoadVendor} error={this.state.errors?.vendor} onChange={this.onChange} >
                    <PersonalinfoPicklist personalinfotypeType='vendor' currentId={this.state.datarow.vendor} onLoad={this.onLoadVendor}/>
                </InputPicklist>
                } 
                {!this.props.disableFields?.includes('employee') &&
                <InputPicklist name='employee' label='Employee' value={this.state.datarow.employee} caption={this.state.datarow.employeeCaption} clearValue={this.onLoadEmployee} error={this.state.errors?.employee} onChange={this.onChange} >
                    <PersonalinfoPicklist personalinfotypeType='employee' currentId={this.state.datarow.employee} onLoad={this.onLoadEmployee}/>
                </InputPicklist>
                }
                <InputPicklist name='division' label='Division' value={this.state.datarow.division} caption={this.state.datarow.divisionCaption} clearValue={this.onLoadDivision} error={this.state.errors?.division} onChange={this.onChange} >
                    <DivisionPicklist currentId={this.state.datarow.division} onLoad={this.onLoadDivision}/>
                </InputPicklist>
                <InputPicklist name='schedule' label='Schedule' value={this.state.datarow.schedule} caption={this.state.datarow.scheduleCaption} clearValue={this.onLoadSchedule} error={this.state.errors?.schedule} onChange={this.onChange} >
                    <SchedulePicklist currentId={this.state.datarow.schedule} onLoad={this.onLoadSchedule}/>
                </InputPicklist>
                </>
                }
                
                </>
                }

            </BaseCreate>
            
            <TransactionpaymentCreate history={this.props.history} transactionId={this.state.datarow.id} save={this.state.saveTransactionpayment} onSave={this.onSaveTransactionpayment} onError={this.onErrorTransactionpayment} disableView/>
            </>
        );
    }     
     
}